<script setup lang="ts">
import { computed } from 'vue';

import type { DataTableCellFormattedType } from '../dataTable.model';

import type { ContentCellContainerPropsType } from './types/contentCellContainerProps.type';

interface Props extends ContentCellContainerPropsType {
  type: DataTableCellFormattedType['type'];
}

const props = defineProps<Props>();

const containerClasses = computed(() => ({
  'border-[#B8B8B8]': props.type === 'dimension',
  'border-[#EBEBEB]': props.type === 'kpi',
  'border-l-0': !props.isFirstColumn,
  'border-t-0': !props.isFirstRow,
  'sticky z-10': props.isFixed
}));
</script>

<template>
  <component
    :is="isFixed ? 'th' : 'td'"
    class="text-sm text-default py-4 border border-solid"
    :class="containerClasses"
    :style="{ left: fixedLeftPosition !== null ? `${fixedLeftPosition}px` : undefined }"
  >
    <slot />
  </component>
</template>
